import NumberFormat from "react-number-format";
import React from "react";
import _ from "lodash";

export default (props) => {
  const {inputRef, onChange, value, ...other} = props;

  const handleValueChange = (values, sourceInfo) => {
    // In case event was triggered not by input - do nothing
    if (sourceInfo.source != 'event') {
      return
    }
    const { floatValue } = values;
    const value = floatValue === undefined ? null : floatValue;
    if (value !== props.value) {
      onChange({
        target: {
          value
        }
      })
    }
  };

  return (
    <NumberFormat
      {...other}
      value={!_.isNil(value) ? value : ''}  // pass '' in case null/undefined to keep input "controlled"
      getInputRef={inputRef}
      onValueChange={handleValueChange}
      thousandSeparator='.'
      decimalSeparator=','
    />
  );
};